import React, { CSSProperties, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, makeStyles, Paper, Typography } from '@material-ui/core';
import { ProductFamily } from 'types/schema-generated-types';

type NoAvailableLicensesPopupProps = {
  dissmissOnClick?: boolean;
  onDismiss?: () => void;
  productFamily?: ProductFamily;
  style?: CSSProperties;
};

const NoAvailableLicensesPopup = ({
  dissmissOnClick = false,
  onDismiss = () => null,
  productFamily,
  style
}: NoAvailableLicensesPopupProps) => {
  const classes = useStyles();
  const { t } = useTranslation('NoAvailableLicensesMessage');

  const assignUnassignBtnId = `assignUnassign${productFamily?.id || ''}Btn`;

  useEffect(() => {
    const clickListener = (event: any) => {
      if (event.target.parentNode?.id === assignUnassignBtnId) {
        return;
      }

      onDismiss();
    };

    if (dissmissOnClick) {
      window.addEventListener('click', clickListener);
    }

    return () => {
      if (dissmissOnClick) {
        window.removeEventListener('click', clickListener);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Paper style={{ ...(style || {}) }}>
      <Box className={classes.popupMessageContainer}>
        <Typography variant="body2">
          {t('Not enough licenses available to assign to the class. Contact your administrator.')}
        </Typography>
      </Box>
    </Paper>
  );
};

const useStyles = makeStyles(theme => ({
  popupMessageContainer: {
    padding: theme.typography.pxToRem(10)
  }
}));

export default NoAvailableLicensesPopup;
